import { Label } from '../atoms/label';

export const HomeFlTable = (props) => {
    const {
        shokaHomeFlList
    } = props;

    return (
        <div className='crawlSenyuubi_tableWrap'>
            <table className='crawlSenyuubi_table'>
                <tr>
                    <th className='crawlSenyuubi_tableHeaderCol' style={style.homeFl}>ご利用月</th>
                    <th className='crawlSenyuubi_tableHeaderCol' style={style.used}>使用済</th>
                    <th className='crawlSenyuubi_tableHeaderCol' style={style.quantity}>残数</th>
                </tr>
                {
                    shokaHomeFlList.map((shokaKenri, index) =>
                        <tr key={"homeFl" + index} >
                            <td className="crawlSenyuubi_tdCol crawlSenyuubi_tdColLeft">
                                <Label label={shokaKenri.homeFl} />
                            </td>
                            <td className="crawlSenyuubi_tdCol">
                                <Label label={shokaKenri.shiyouzumi} />
                            </td>
                            <td className="crawlSenyuubi_tdCol">
                                <Label label={shokaKenri.zansu} />
                            </td>
                        </tr>
                    )
                }
            </table>
        </div>
    )
}

const style = {
    homeFl: {
        width: "40%",
    },
    used: {
        width: "30%",
    },
    quantity: {
        width: "30%",
    }
}